import { httpV2 } from "../http.js";

const WorkSchedulesService = {
  // Get all recipients with their schedules
  listRecipientsWithSchedules: (criteria = {}) => {
    const params = new URLSearchParams(criteria).toString();
    return httpV2.get(`/work-schedules/list${params ? `?${params}` : ""}`);
  },

  // Get schedules for a specific recipient
  getSchedules: (recipient_id) =>
    httpV2.get(`/work-schedules/schedules/${recipient_id}`),

  // Create schedules for a recipient
  createSchedules: (recipient_id, schedules) =>
    httpV2.post(`/work-schedules/schedules/${recipient_id}`, { schedules }),

  // Update schedules for a recipient
  updateSchedules: (recipient_id, schedules) =>
    httpV2.put(`/work-schedules/schedules/${recipient_id}`, { schedules }),

  // Delete schedules for a recipient
  deleteSchedules: (recipient_id) =>
    httpV2.delete(`/work-schedules/schedules/${recipient_id}`),

  // Get exceptions for a specific recipient
  getExceptionsByRecipient: (recipient_id) =>
    httpV2.get(`/work-schedules/exceptions/recipient/${recipient_id}`),

  // Create an exception
  createException: (exceptionData) =>
    httpV2.post("/work-schedules/exceptions", exceptionData),

  // Update an exception
  updateException: (exception_id, exceptionData) =>
    httpV2.put(`/work-schedules/exceptions/${exception_id}`, exceptionData),

  // Delete an exception
  deleteException: (exception_id) =>
    httpV2.delete(`/work-schedules/exceptions/${exception_id}`),

  // Get availability for assignees
  getAvailability: (start_date, end_date) => {
    const params = new URLSearchParams({
      start_date,
      end_date,
    }).toString();
    return httpV2.get(`/work-schedules/availability?${params}`);
  },

  // Get holidays for a country
  getHolidays: (country_code = 'US', date_from = null, date_to = null) => {
    const params = new URLSearchParams({ country_code });
    if (date_from) params.append('date_from', date_from);
    if (date_to) params.append('date_to', date_to);
    return httpV2.get(`/work-schedules/holidays?${params.toString()}`);
  },
};

export default WorkSchedulesService;
